(function () {
  'use strict';

  function formatMoney(cents, currency) {
    if (window.Currency && typeof window.Currency.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Currency.formatMoney(cents, window.theme.moneyFormat);
    }

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'CAD'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function buildReturnTo(productUrl, variantId, alertId) {
    return productUrl + '?variant=' + variantId + '#' + alertId;
  }

  function initializeRestockAlert(alert, initialVariant) {
    if (!alert || alert.dataset.restockInitialized === 'true') {
      return;
    }

    alert.dataset.restockInitialized = 'true';

    var productSection = alert.closest('[data-section-type="product"]');
    var form = alert.querySelector('form');
    var initialVariantElement = alert.querySelector('[data-restock-initial-variant]');
    var tagInput = alert.querySelector('[data-restock-tags]');
    var priceElements = alert.querySelectorAll('[data-restock-price]');
    var titleElements = alert.querySelectorAll('[data-restock-variant-title]');
    var submitButton = alert.querySelector('[data-restock-submit]');
    var returnToInput = form ? form.querySelector('input[name="return_to"]') : null;
    var currentVariant = initialVariant || null;

    if (!currentVariant && initialVariantElement) {
      try {
        currentVariant = JSON.parse(initialVariantElement.textContent);
      } catch (error) {
        currentVariant = null;
      }
    }

    function showSuccess() {
      if (!form) {
        return;
      }

      var variantTitle = currentVariant && currentVariant.title === 'Default Title'
        ? alert.dataset.productTitle
        : currentVariant && currentVariant.title;

      form.innerHTML = '';

      var success = document.createElement('div');
      success.className = 'restock-alert__status restock-alert__status--success';
      success.setAttribute('role', 'status');
      success.setAttribute('aria-live', 'polite');

      var heading = document.createElement('strong');
      heading.textContent = 'You are on the list.';

      var message = document.createElement('span');
      message.textContent = 'We will email you when ' + (variantTitle || 'this item') + ' is available again.';

      success.appendChild(heading);
      success.appendChild(message);
      form.appendChild(success);
    }

    function update(variant) {
      if (!variant) {
        alert.hidden = true;
        return;
      }

      currentVariant = variant;
      alert.hidden = Boolean(variant.available);

      if (variant.available) {
        return;
      }

      var variantTitle = variant.title === 'Default Title' ? alert.dataset.productTitle : variant.title;
      var timestamp = Math.floor(Date.now() / 1000);

      titleElements.forEach(function (element) {
        element.textContent = variantTitle;
      });

      priceElements.forEach(function (element) {
        element.textContent = formatMoney(variant.price, alert.dataset.currency);
      });

      if (tagInput) {
        tagInput.value = [
          'restock-alert',
          'restock-variant-' + variant.id,
          'restock-price-' + variant.id + '-' + timestamp + '-' + variant.price
        ].join(',');
      }

      if (returnToInput) {
        returnToInput.value = buildReturnTo(alert.dataset.productUrl, variant.id, alert.id);
      }
    }

    if (productSection) {
      productSection.addEventListener('variant:changed', function (event) {
        update(event.detail && event.detail.variant);
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        update(currentVariant);

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Registering...';
        }
      });
    }

    update(currentVariant);

    if (window.location.hash === '#' + alert.id && new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
      showSuccess();
    }
  }

  function createRestockAlert(productSection, product, selectedVariant) {
    var insertionPoint = productSection.querySelector('.product-form__payment-container');

    if (!insertionPoint || !product || !selectedVariant) {
      return null;
    }

    var alertId = 'restock-alert-' + productSection.dataset.sectionId + '-' + product.id;
    var formId = 'RestockAlertForm-' + productSection.dataset.sectionId + '-' + product.id;
    var alert = document.createElement('aside');

    alert.id = alertId;
    alert.className = 'restock-alert';
    alert.dataset.restockAlert = '';
    alert.dataset.productTitle = product.title;
    alert.dataset.productUrl = product.url || window.location.pathname;
    alert.dataset.currency = (window.theme && window.theme.currencyCode) || 'CAD';
    alert.setAttribute('aria-labelledby', alertId + '-title');

    alert.innerHTML = [
      '<div class="restock-alert__heading">',
      '<span class="restock-alert__eyebrow">Currently unavailable</span>',
      '<h2 id="' + alertId + '-title" class="restock-alert__title">Email me when it is back in stock</h2>',
      '</div>',
      '<form method="post" action="/contact#contact_form" accept-charset="UTF-8" id="' + formId + '" class="restock-alert__form">',
      '<input type="hidden" name="form_type" value="customer">',
      '<input type="hidden" name="utf8" value="✓">',
      '<input type="hidden" name="return_to" value="">',
      '<input type="hidden" name="contact[tags]" value="" data-restock-tags>',
      '<p class="restock-alert__description">Request an alert for <strong data-restock-variant-title></strong>. We will include its current price and let you know if it changed since your request.</p>',
      '<div class="restock-alert__selection" aria-live="polite">',
      '<span class="restock-alert__selection-label">Selected:</span>',
      '<span data-restock-variant-title></span>',
      '<span aria-hidden="true">·</span>',
      '<span data-restock-price></span>',
      '</div>',
      '<div class="restock-alert__controls">',
      '<div class="restock-alert__field">',
      '<label for="' + formId + '-email">Email address</label>',
      '<input id="' + formId + '-email" class="restock-alert__email" type="email" name="contact[email]" placeholder="your@email.com" autocomplete="email" autocapitalize="off" spellcheck="false" required>',
      '</div>',
      '<button class="btn restock-alert__submit" type="submit" data-restock-submit>Notify me</button>',
      '</div>',
      '<label class="restock-alert__consent">',
      '<input type="checkbox" required>',
      '<span>I agree to receive this restock alert by email. I can unsubscribe at any time.</span>',
      '</label>',
      '</form>'
    ].join('');

    insertionPoint.insertAdjacentElement('afterend', alert);
    initializeRestockAlert(alert, selectedVariant);

    return alert;
  }

  function initializeProductSection(productSection) {
    if (!productSection || productSection.dataset.restockSectionInitialized === 'true') {
      return;
    }

    productSection.dataset.restockSectionInitialized = 'true';

    var productJsonElement = productSection.querySelector('[data-product-json]');

    if (!productJsonElement) {
      return;
    }

    var data;

    try {
      data = JSON.parse(productJsonElement.textContent);
    } catch (error) {
      return;
    }

    var product = data.product;
    var selectedVariant = product && product.variants && product.variants.find(function (variant) {
      return Number(variant.id) === Number(data.selected_variant_id);
    });
    var alert = productSection.querySelector('[data-restock-alert]');

    if (alert) {
      initializeRestockAlert(alert, selectedVariant);
    } else {
      createRestockAlert(productSection, product, selectedVariant);
    }
  }

  function initializeWithin(container) {
    if (!container || !container.querySelectorAll) {
      return;
    }

    if (container.matches && container.matches('[data-section-type="product"]')) {
      initializeProductSection(container);
    }

    container.querySelectorAll('[data-section-type="product"]').forEach(initializeProductSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();
